import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxPrintModule } from 'ngx-print';

@Component({
    selector: 'lib-print-landscape-a11-template',
    imports: [
        MatButtonModule,
        MatIconModule,
        NgxPrintModule
    ],
    templateUrl: './print-landscape-A11-template.component.html',
    styleUrl: './print-landscape-A11-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintLandscapeA11TemplateComponent { }
